import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "@/features/policy";

export const Route = createFileRoute("/policy")({
  validateSearch: (search: Record<string, unknown>) => ({
    lang: (search.lang as string) || undefined,
  }),
  component: PolicyRoute,
});

function PolicyRoute() {
  const { lang } = Route.useSearch();
  return <PolicyPage initialLang={lang} />;
}
